import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'collegeevents.filters.list.header',
    defaultMessage: 'Filters',
  },
  navianceHeader: {
    id: 'collegeevents.filters.list.naviance-header',
    defaultMessage: 'Naviance Filters',
  },
  sortFiltersBy: {
    id: 'collegeevents.filters.list.sort-filters-by',
    defaultMessage: 'Sort filters by',
  },
  recommendedTo: {
    id: 'collegeevents.filters.list.recommends',
    defaultMessage: 'Recommended to',
  },
  assignedTo: {
    id: 'collegeevents.filters.list.assigned',
    defaultMessage: 'Assigned to',
  },
  name: {
    id: 'collegeevents.filters.list.name',
    defaultMessage: 'Name',
  },
  create: {
    id: 'collegeevents.filters.list.create',
    defaultMessage: 'Create filter',
  },
  liveEvents: {
    id: 'collegeevents.filters.list.events',
    defaultMessage: 'live {events, plural, =0 {events} one {event} other {events}}',
  },
  students: {
    id: 'collegeevents.filters.list.students',
    defaultMessage: '{students, plural, =0 {students} one {student} other {students}}',
  },
  rename: {
    id: 'collegeevents.filters.list.rename',
    defaultMessage: 'Rename',
  },
  duplicate: {
    id: 'collegeevents.filters.list.duplicate',
    defaultMessage: 'Duplicate',
  },
  deleteFilter: {
    id: 'collegeevents.filters.list.delete',
    defaultMessage: 'Delete',
  },
  confirmDeleteHeader: {
    id: 'collegeevents.filters.delete.header',
    defaultMessage: 'Are you sure you want to delete this filter?',
  },
  confirmDeleteMsg: {
    id: 'collegeevents.filters.delete.message',
    defaultMessage: 'If this filter is currently assigned to any event, it will be removed from that event.',
  },
  confirmDeleteYes: {
    id: 'collegeevents.filters.delete.confirm',
    defaultMessage: 'Delete',
  },
  confirmDeleteCancel: {
    id: 'collegeevents.filters.delete.cancel',
    defaultMessage: 'Cancel',
  },
  deleteSuccessTitle: {
    id: 'collegeevents.filters.delete.success-title',
    defaultMessage: 'Filter Deleted',
  },
  deleteSuccessDescription: {
    id: 'collegeevents.filters.delete.success-description',
    defaultMessage: 'The Event Filter was successfully deleted.',
  },
  error: {
    id: 'collegeevents.filters.list.error',
    defaultMessage: 'There was an error while trying to execute the desired action.',
  },
  errorUniqueName: {
    id: 'collegeevents.filters.list.error.uniqueName',
    defaultMessage: 'Filter name should be unique.',
  },
  missingFilterName: {
    id: 'collegeevents.filters.rename.missingFilterName',
    defaultMessage: 'Filter Name is required',
  },
  renameName: {
    id: 'collegeevents.filters.rename.name',
    defaultMessage: 'Filter Name',
  },
  renameSubmit: {
    id: 'collegeevents.filters.rename.submit',
    defaultMessage: 'Submit',
  },
  renameSuccessTitle: {
    id: 'collegeevents.filters.rename.success-title',
    defaultMessage: 'Filter Renamed',
  },
  renameSuccessDescription: {
    id: 'collegeevents.filters.rename.success-description',
    defaultMessage: 'The Event Filter was successfully renamed.',
  },
  recommendsTo: {
    id: 'collegeevents.filters.list.recommends',
    defaultMessage: 'Recommended to',
  },
});

export default messages;
